const $ = jQuery.noConflict();

class Slider {
    constructor(selector, args = {}, externalControls = false) {
        this.selector = selector;
        this.args = args;
        this.externalControls = externalControls;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        };
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign({}, this.getDefaultSlickSettings(), this.args);
    }

    getExternalControlsSettings(settings, selector) {
        const newSettings = {
            arrows: true,
            prevArrow: $(selector).parent().find('.slick-prev'),
            nextArrow: $(selector).parent().find('.slick-next'),
        };

        return Object.assign({}, settings, newSettings);
    }

    init() {
        let settings = this.getSlickSettings();

        if (this.externalControls) {
            settings = this.getExternalControlsSettings(settings, this.selector);

            $(this.selector).on('afterChange', (event, slick, currentSlide) => {
                slick.$slider.parent().find('.slick-current-slide-number').text(currentSlide + 1);
            });
        }

        $(this.selector).slick(settings);
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider');

const AlertSlider = new Slider('.block-alert-slider__slider', {
    dots: false,
    infinite: false
}, true);

const TestimonialSlider = new Slider('.block-testimonial-slider .container .testimonial-slider', {
    infinite: true,
    centerPadding: '0px',
    responsive: [{
        breakpoint: 1300,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            variableWidth: false,
            centerPadding: '0px'
        }
    }

    ]
});

const TestimonialSliderFluid = new Slider('.block-testimonial-slider--fluid .testimonial-slider', {
    centerMode: true,
    variableWidth: true,
    infinite: true,
    centerPadding: '0px',
    responsive: [{
        breakpoint: 1300,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            variableWidth: false,
            centerPadding: '0px'
        }
    }

    ]
});

const FluidSlider = new Slider(
    '.gallery-slider__slider-fluid',
    {
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1290,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    }
);
export { SimpleSlider, TestimonialSlider, TestimonialSliderFluid, FluidSlider, AlertSlider };
